<template
  :element-loading-text="$locale('global.loading')"
  element-loading-spinner="el-icon-loading"
>
  <div class="page-content accumulated">
    <h1 class="page-title">{{ $locale("sideMenu.reports.accumulated") }}</h1>
    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :md="5" :sm="12">
        <CommDatePicker v-model="filter.date" :value.sync="filter.date" :showWeekly="true" />
      </el-col>
      <el-col :md="2" :sm="12">
        <el-checkbox v-model="unDisplayNoBoxOffice">{{ $locale("trans.box.freeMobilize") }}</el-checkbox>
      </el-col>
      <el-col :md="9" :sm="12">
        <el-button class="egl-btn-yellow" @click="search_fn">{{ $locale("global.confirm2") }}</el-button>
      </el-col>
      <el-col class="ta-r" :md="8" :sm="12">
        <el-button @click="exportCsv" class="egl-btn-yellow">{{
          $locale("global.exportToCSV")
        }}</el-button>
        <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
      </el-col>
    </el-row>
     <!-- table -->
     <div id="print">
      <div class="table-module">
      <el-row class="tableLabel">
        <el-col :span="3">{{ $locale("sideMenu.reports.accumulated") }}</el-col>
        <el-col :span="4"
          >{{ $locale("dailyClosing.th.cinemaName") }} :
          {{ tableLabel.cinemaName }}</el-col
        >
        <el-col :span="17" class="ta-r"
          >{{ $locale("trans.report.generatedate") }} :
          {{ tableLabel.createTime }}</el-col
        >
      </el-row>
      <el-row class="tableLabel">
        <el-col :span="6"
          >{{ $locale("business.date") }} : {{ tableLabel.duration }}</el-col
        >
      </el-row>
      <el-table
        class="egl-table payTable"
        :data="tableData"
        border
        :span-method="merge4arrayMethod"
        :cell-class-name="totalName"
        @filter-change="filterChange_fn"
        @sort-change="sortChange_fn"
      >
        <el-table-column
          :label="$locale('global.titleOfWork')"
          prop="name"
          min-width="160"
          :filters="filters.film"
          column-key="film"
        ></el-table-column>
        <el-table-column
          :label="$locale('global.versions')"
          prop="version"
          min-width="160"
          :filters="versionList.concat(otherVersionList)"
          column-key="version"
        ></el-table-column>
        <el-table-column
          :label="$locale('report.saleWeekly.publicWeek')"
          prop="week"
          sortable="custom"
          min-width="100px"
        ></el-table-column>
        <el-table-column
          :label="$locale('movie.distribution')"
          prop="clientName"
          min-width="160"
          :filters="filters.clientName"
          column-key="clientName"
        ></el-table-column>
        <el-table-column
          :label="$locale('report.saleWeekly.dayTotal')"
          align="center"
        >
          <el-table-column
            :label="$locale('cashierReport.dialog.th.cashQty')"
            min-width="120"
            prop="daily.qty"
          ></el-table-column>
          <el-table-column
            :label="$locale('cashierReport.dialog.th.amount')"
             prop="daily.amount"
             min-width="160"
             :formatter="priceFormat"
          ></el-table-column>
        </el-table-column>
        <el-table-column
          :label="$locale('report.saleWeekly.weekTotal')"
          align="center"
        >
          <el-table-column
            :label="$locale('cashierReport.dialog.th.cashQty')"
            prop="weekly.qty"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$locale('cashierReport.dialog.th.amount')"
            prop="weekly.amount"
            min-width="160"
            :formatter="priceFormat"
          ></el-table-column>
        </el-table-column>
        <el-table-column
          :label="$locale('report.cinemaDaily.monthTotal')"
          align="center"
        >
          <el-table-column
            :label="$locale('cashierReport.dialog.th.cashQty')"
            prop="monthly.qty"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$locale('cashierReport.dialog.th.amount')"
            prop="monthly.amount"
            min-width="160"
            :formatter="priceFormat"
          ></el-table-column>
        </el-table-column>
        <el-table-column
          :label="$locale('report.accumulated.total')"
          align="center"
        >
          <el-table-column
            :label="$locale('cashierReport.dialog.th.cashQty')"
            prop="accumulated.qty"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$locale('cashierReport.dialog.th.amount')"
            prop="accumulated.amount"
            min-width="160"
            :formatter="priceFormat"
          ></el-table-column>
        </el-table-column>
      </el-table>
    </div>
     </div>
    
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommDatePicker from "@/components/common/CommDatePicker";
import { getAccumulatedReportList } from "@/helpers/service/api/accumulated";
import "@/assets/style/report.less";
import { toThousands } from "@/utils/common";
import { getVersion, getOtherVersion } from "@/helpers/service/api/common";
import { exportCSV_fn } from "@/assets/js/accumulated_exportCSV";

export default {
  created() {
    getVersion({ cinemaId: this.cinemaId, page: 0, pageSize: 9999 }).then(res => {
      this.versionList = res.data.data.map(item => ({
        text: item.name,
        value: item.name,
      }));
    });
    getOtherVersion({ cinemaId: this.cinemaId, page: 0, pageSize: 9999 }).then(res => {
      this.otherVersionList = res.data.data.map(item => ({
        text: item.name,
        value: item.name
      }));
    });
  },
  data() {
    return {
      printObj: {
        popTitle: this.$locale("sideMenu.reports.accumulated"),
        id: "print"
      },
      filter: {
        date: this.$moment().startOf("day").valueOf()
      },
      tableLabel: {
        cinemaName: "",
        createTime: "",
        duration: "",
      },
      originData: {},
      filters: {
        film: [],
        clientName: [],
      },
      versionList: [],
      otherVersionList: [],
      filterTypes: {
        type: "",
        filters: [],
      },
      sortTypes: "",
      unDisplayNoBoxOffice: false,
    };
  },
  computed: {
    ...mapState("app", {
      cinemaId: state => state.cinemaId,
    }),
    tableData() {
      return this.formatTableData();
    }
  },
  methods: {
    addSubTotalData(arr, film) {
      arr.push({
        type: "subTotal",
        name: film.filmName,
        version:  this.$locale("reprot.accumulated.totalMovie"),
        week: "",
        clientName: "",
        daily: {
          qty: film.versionRecords.reduce((total, item) => total + item.daily.qty, 0),
          amount: film.versionRecords.reduce((total, item) => total + item.daily.amount, 0),
        },
        weekly: {
          qty: film.versionRecords.reduce((total, item) => total + item.weekly.qty, 0),
          amount: film.versionRecords.reduce((total, item) => total + item.weekly.amount, 0),
        },
        monthly: {
          qty: film.versionRecords.reduce((total, item) => total + item.monthly.qty, 0),
          amount: film.versionRecords.reduce((total, item) => total + item.monthly.amount, 0),
        },
        accumulated: {
          qty: film.versionRecords.reduce((total, item) => total + item.accumulated.qty, 0),
          amount: film.versionRecords.reduce((total, item) => total + item.accumulated.amount, 0),
        }
      });
    },
    addSubTotalDataForFilter(arr, film) {
      arr.push({
        type: "subTotal",
        name: film.filmName,
        version:  this.$locale("reprot.accumulated.totalMovie"),
        week: "",
        clientName: "",
        daily: {
          qty: arr.reduce((total, item) => total + item.daily.qty, 0),
          amount: arr.reduce((total, item) => total + item.daily.amount, 0),
        },
        weekly: {
          qty: arr.reduce((total, item) => total + item.weekly.qty, 0),
          amount: arr.reduce((total, item) => total + item.weekly.amount, 0),
        },
        monthly: {
          qty: arr.reduce((total, item) => total + item.monthly.qty, 0),
          amount: arr.reduce((total, item) => total + item.monthly.amount, 0),
        },
        accumulated: {
          qty: arr.reduce((total, item) => total + item.accumulated.qty, 0),
          amount: arr.reduce((total, item) => total + item.accumulated.amount, 0),
        }
      });
    },
    formatTableData() {
      let _arr = [];
      let _origin = {};
      if (this.originData.filmRecords && this.filterTypes.type && this.filterTypes.filters.length > 0) {
        if (this.filterTypes.type === "film") {
          _origin.filmRecords = this.originData.filmRecords.filter(item => this.filterTypes.filters.includes(item.filmName));
        }
        else if (this.filterTypes.type === "clientName") {
          _origin.filmRecords = this.originData.filmRecords.map(item => ({
            filmName: item.filmName,
            versionRecords: item.versionRecords.filter(record => this.filterTypes.filters.includes(record.clientName))
          }));
        }
        else if (this.filterTypes.type === "version") {
          _origin.filmRecords = this.originData.filmRecords.map(item => ({
            filmName: item.filmName,
            versionRecords: item.versionRecords.filter(record => this.$_.intersection(this.filterTypes.filters, record.version.split(",")).length > 0)
          }));
        }
      } else {
        _origin = this.originData;
      }
      if (_origin.filmRecords) {
        // sort
        if (this.sortTypes) {
          _origin.filmRecords.forEach(item => {
            item.versionRecords = this.$_.orderBy(item.versionRecords, [ "week" ], [ this.sortTypes === "descending" ? "desc" : "asc" ]);
          });
        }
        _origin.filmRecords.forEach(film => {
          if (film.versionRecords.length > 0) {
            film.versionRecords.forEach(record => {
              _arr.push({
                name: film.filmName,
                ...record,
              });
            });
            this.addSubTotalData(_arr, film);
          }
        });
        if (_origin.filmRecords.some(item => item.versionRecords.length > 0)) {
          _arr.push({
            type: "allTotal",
            name: this.$locale("report.ticketSales.allTotal"),
            version: "",
            week: "",
            clientName: "",
            daily: {
              qty: _arr.filter(item => item.type === "subTotal").reduce((total, item) => total + item.daily.qty, 0),
              amount: _arr.filter(item => item.type === "subTotal").reduce((total, item) => total + item.daily.amount, 0),
            },
            weekly: {
              qty: _arr.filter(item => item.type === "subTotal").reduce((total, item) => total + item.weekly.qty, 0),
              amount: _arr.filter(item => item.type === "subTotal").reduce((total, item) => total + item.weekly.amount, 0),
            },
            monthly: {
              qty: _arr.filter(item => item.type === "subTotal").reduce((total, item) => total + item.monthly.qty, 0),
              amount: _arr.filter(item => item.type === "subTotal").reduce((total, item) => total + item.monthly.amount, 0),
            },
            accumulated: {
              qty: _arr.filter(item => item.type === "subTotal").reduce((total, item) => total + item.accumulated.qty, 0),
              amount: _arr.filter(item => item.type === "subTotal").reduce((total, item) => total + item.accumulated.amount, 0),
            }
          });
        }
        return _arr;
      }
    },
    getCount(model, key) {
      let spanArr = [];
      let pos = 0;
      for(let i = 0; i < model.length; i++) {
        if (i === 0) {
          spanArr.push(1);
          pos = 0;
        } else if (model[i][key] === model[i - 1][key]) {
          spanArr[pos] += 1;
          spanArr.push(0);
        } else {
          spanArr.push(1);
          pos = i;
        }
      }
      return spanArr;
    },
    mergeComon(key, rowIndex) {
      const _row = this.getCount(this.tableData, key)[rowIndex];
      const _col = _row > 0 ? 1: 0;
      return {
        rowspan: _row,
        colspan: _col
      };
    },
    merge4arrayMethod({ row, rowIndex, columnIndex }) {
      if (row.type === "allTotal") {
        if (columnIndex === 0) {
          return  [1, 4];
        } else if (columnIndex > 0 && columnIndex < 4) {
          return [0, 0];
        }
      }
      if (row.type === "subTotal") {
        if (columnIndex === 1) {
          return [1, 3];
        } else if (columnIndex > 1 && columnIndex < 4) {
          return [0, 0];
        }
      }
      switch(columnIndex) {
      case 0:
        return this.mergeComon("name", rowIndex, columnIndex);
      default:
        break;
      }
    },
    exportCsv() {
      exportCSV_fn({
        cinemaId: this.cinemaId,
        reportDate: this.$moment(this.filter.date).format("YYYY-MM-DD"),
        unDisplayNoBoxOffice: this.unDisplayNoBoxOffice,
      });
    },
    search_fn() {
      getAccumulatedReportList({
        cinemaId: this.cinemaId,
        reportDate: this.$moment(this.filter.date).format("YYYY-MM-DD"),
        unDisplayNoBoxOffice: !this.unDisplayNoBoxOffice,
      }).then(res => {
        this.tableLabel = {
          cinemaName: res.data.cinema,
          createTime: this.$moment(res.data.exportDate).format("YYYY-MM-DD (ddd) HH:mm:ss"),
          duration: `${this.$moment(res.data.reportDate).format("YYYY-MM-DD (ddd)")} ${this.$locale("report.accumulated.until")}`
        };
        this.originData = res.data;
        this.filters.film = this.$_.uniqBy(this.originData.filmRecords.map(item => ({
          text: item.filmName,
          value: item.filmName
        })), "text");
        this.originData.filmRecords.forEach(film => {
          film.versionRecords.forEach(record => {
            this.filters.clientName.push({
              text: record.clientName,
              value: record.clientName
            });
          });
        });
        this.filters.clientName = this.$_.uniqBy(this.filters.clientName, "text");
      });
    },
    priceFormat(row, column, cellValue) {
      switch(column.property) {
      case "daily.amount":
        return "¥" + toThousands(cellValue);
      case "weekly.amount":
        return "¥" + toThousands(cellValue);
      case "monthly.amount":
        return "¥" + toThousands(cellValue);
      case "accumulated.amount":
        return "¥" + toThousands(cellValue);
      default:
        return cellValue;
      }
    },
    totalName({ row, columnIndex }) {
      if (row.type === "subTotal" || row.type === "allTotal") {
        if (row.type === "allTotal" && columnIndex === 0) {
          return "allTotalBg";
        }
        if (columnIndex > 3) {
          return "subTotal-num";
        }
        return "subTotal";
      }
    },
    filterChange_fn(filters) {
      this.filterTypes = {
        type: Object.keys(filters)[0],
        filters: filters[Object.keys(filters)[0]]
      };
    },
    sortChange_fn(value) {
      this.sortTypes = value.order;
    }
  },
  components: {
    CommDatePicker,
  }
};
</script>